import { render, staticRenderFns } from "./binding.vue?vue&type=template&id=5c0ba298"
import script from "./binding.vue?vue&type=script&lang=js"
export * from "./binding.vue?vue&type=script&lang=js"
import style0 from "./binding.vue?vue&type=style&index=0&id=5c0ba298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports